export default __webpack_public_path__ + "static/media/Ashley.8a59548c.png";